/* eslint-disable no-eval */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import VMasker from 'vanilla-masker'
// import { ddi } from '../../service/ddiService'
import classNames from 'classnames'
import loadingImg from '../../assets/images/loading-green.svg'
import placeholderflag from '../../assets/images/placeholder-flag.png'

import './fieldTelefone.scss'

const initialState = {
  visitedInput: false,
  className: '',
  errors: [],
  errorDescription: '',
  type: '',
  ariaInvalid: false,
  asyncLoading: false,
  validations: {
    required: false,
    minlength: null,
    maxlength: null,
    min: null,
    max: null,
    pattern: '',
  },
  ddi: ''
}

const fieldValidationMessage = {
  'valueMissing': () => 'Este campo é obrigatório.',
  'tooShort': value => `Este campo deve ter no mínimo ${value.validations.minlength} caracteres.`,
  'tooLong': value => `Este campo deve ter no máximo ${value.validations.maxlength} caracteres.`,
  'rangeUnderflow': value => `Valor mínimo permitido é ${value.validations.min}.`,
  'rangeOverflow': value => `Valor máximo permitido é ${value.validations.max}.`,
  'patternMismatch': value => `${value.label} inválido!`,
  'typeMismatch': value => `${value.label} inválido!`,
}

class FieldTelefone extends Component {
  _isMounted = false;

  constructor(props) {
    super(props)
    this.handleFocus = this.handleFocus.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.validateAsync = this.validateAsync.bind(this)
    this.bindMask = this.bindMask.bind(this)
  }
  state = { ...initialState, ddiList: this.props.listPais }

  componentWillMount() {
    let { returnObject } = this.props;

    if (returnObject) {
      returnObject(this)
    }

    if (this.props.value) {
      if (this.props.type !== "ddi") {
        this.setState({ phone: this.props.value })
      } else {
        const ddi = this.props.listPais;
        let pais = null;

        for (let i = 2; i <= 4; i++) {

          if (this.props.idDDIpais !== null) {
            pais = ddi.filter(item => {
              return item.IdPais ===  this.props.idDDIpais
            })
          } else {
            let ddiSub = this.props.value.replace("+", "").substr(0, i);
            pais = ddi.filter(item => {
              return item.DDI === ddiSub
            })
          }         

          if (pais.length > 0) {
            if (pais.length > 1) {
              this.setState({ddiList: pais, selectToggle: true});              
            } else {
              var newState = {};
              newState.DDI = pais[0].DDI
              newState.ArquivoBandeira = pais[0].ArquivoBandeira
              newState.Nome = pais[0].Nome
              this.setState({ddiList: ddi, selectToggle: false, ...newState})
              
              const {onChangeDDI, onChange, name} = this.props;

              if (onChangeDDI)
                onChangeDDI(pais[0].IdPais);
          
              if (onChange)
                onChange(name, pais[0].DDI)
            }

            break
          }

        }

      }
    }
  }
  componentDidMount() {
    this._isMounted = true;
    this.setValidations(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this.setValidations(nextProps)
  }

  componentWillUnmount() {
    this._isMounted = false;
  }
  render() {

    let selectClassNames = classNames({
      'select': true,
      'open-select': this.state.selectToggle,
    })



    let { value, loading } = this.props
    let { handleChange } = this

    let fieldClassNames = classNames({
      'field': true,
      'has-value': !!value
    },
      this.state.className)
    return (

      <div className="tel-conteiner">

        {/* html DDI */}
        {this.props.type === "ddi" && (
          <div className="select-container">
            <div className={selectClassNames} onClick={this.props.selectToogle ? this.selectToggle : null}>
              <div data-value="" className="default">  
                <img src={this.state.ArquivoBandeira ? this.state.ArquivoBandeira : placeholderflag} alt={this.state.Nome} />
              </div>              
              <div className="container-options">
                {this.state.ddiList.map((i, index) => (
                  <div key={index} data-value="1" className="option" onClick={() => this.onClickSelectItem(i)}>
                    <img src={i.ArquivoBandeira ? i.ArquivoBandeira : placeholderflag} alt={i.Nome} />
                    <label>{i.Nome}</label>
                  </div>
                ))}
              </div>                      
              <div className="dot"></div>
            </div>
            
          </div> 
        )}  

        <div className="field-container">
          <label htmlFor={this.props.name} className={fieldClassNames}>

            <input
              id={this.props.name}
              placeholder="&nbsp;"
              name={this.props.name}
              type="tel"
              value={this.props.type === "ddi" ? (value.includes("+") ? value : `+${value}`) : value}
              required={this.state.validations.required}
              pattern={this.state.validations.pattern ? this.state.validations.pattern : null}
              disabled={this.state.disabled}
              readOnly={this.props.readOnly}
              min={this.state.validations.min}
              max={this.state.validations.max}
              minLength={this.state.validations.minlength}
              maxLength={this.state.validations.maxlength}
              aria-invalid={this.state.ariaInvalid}
              onFocus={this.handleFocus}
              onBlur={this.handleBlur}
              onChange={handleChange}
              ref={input => { this.input = input }}
            />
            {loading && <i className="icon"> <img src={loadingImg} alt="loading" /></i>}
            <span className="label">{this.state.validations.required ? this.props.label + ' *' : this.props.label}</span>
            <span className="border"></span>
            <small className="message">{this.state.errorDescription}</small>


          </label>
        </div>
      </div>
    )
  }

  setValidations = (props) => {
    let validations = {
      required: props.hasOwnProperty('required') ? props.required : this.state.validations.required,
      minlength: props.hasOwnProperty('minlength') ? props.minlength : this.state.validations.minlength,
      maxlength: props.hasOwnProperty('maxlength') ? props.maxlength : this.state.validations.maxlength,
      min: props.hasOwnProperty('min') ? props.min : this.state.validations.min,
      max: props.hasOwnProperty('max') ? props.max : this.state.validations.max,
      pattern: props.hasOwnProperty('pattern') ? props.pattern : this.state.validations.pattern
    }
    this.setState({ validations: validations })
  }


  handleFocus = event => {
    this.setState({ visitedInput: true })

    if (this.state.visitedInput === false) {
      this.bindMask(event.target);
    }
  }

  handleChange = event => {
    event.preventDefault()

    this.bindMask(event.target);

    this.onChangeInputPhone(event)

    let { name, value } = event.target
    let { onChange } = this.props

    if (onChange) {
      onChange(name, value)
    }
  }

  handleBlur = event => {
    event.preventDefault()
    this.validate(event.target)
  }

  bindMask = target => {
    let { type } = this.props

    if (type === 'ddi') {
      VMasker(target).maskPattern("+9999")
    } else if (this.props.ddiForMask === "55" && type === 'cel') {
      VMasker(target).maskPattern("(99) 99999-9999")
    } else if (this.props.ddiForMask === "55" && type === 'tel') {
      VMasker(target).maskPattern("(99) 9999-9999")
    } else {
      VMasker(target).maskPattern("9999999999999999999")
    }
  }


  validate = field => {
    let fieldValidityState = null
    return new Promise((resolve, reject) => {

      if (!field.checkValidity()) {
        fieldValidityState = field.validity

        let errorType = this.validatePropertiesValidityState(fieldValidityState)
        reject({ message: fieldValidationMessage[errorType]({ ...this.props, ...this.state }) })
      } else if (this.props.type === "ddi" && !this.state.DDI && this.props.required) {
        reject({ message: "Nenhum país selecionado!" })
        this.setState({ paisNotexist: true })
      } else if (this.props.type !== "ddi" && this.state.phone && this.state.phone.length > this.state.validations.maxlength) {
        reject({ message: `Máx. ${this.state.validations.maxlength} dígitos.` })
      }    
      // else if (!this.state.ddi && field.value) {
      //   reject({ message: "Nenhum país selecionado!" })
      //   this.setState({ paisNotexist: true })
      // }

      // if(field.value.length < 8 && this.props.required)
      //   reject({message:"Telefone deve ser preenchido!"})
      
        let resultValidateSync = this.validateSync(field.value)
      if (resultValidateSync !== true)
        reject(resultValidateSync)

      this.setState({ asyncLoading: true })
      resolve(field.value)
    })
      .then(this.validateAsync)
      .then(() => {
        this.setState({ className: 'info', errorDescription: '' })
        field.setCustomValidity('')

        return true
      })
      .catch(error => {
        this.setState({ className: 'danger', errorDescription: error.message })
        let { onError } = this.props
        if (onError)
          onError({ name: this.props.name, errorDescription: error.message })

        return false
      }).finally(() => {
        this.setState({ asyncLoading: false })
        return this.state
      })
  }

  async validateAsync(value) {
    if (typeof (this.props.validateAsync) === "function")
      return await this.props.validateAsync(value)
    return true
  }

  validateSync = value => {
    if (!this.props.validateSync)
      return true

    return this.props.validateSync(value)
  }


  validatePropertiesValidityState = validityState => {
    for (var key in validityState) {
      if (validityState[key] === true && key !== 'valid')
        return key
    }
  }

  onChangeInputPhone = event => {
    const ddi = this.props.listPais;
    let value = event.target.value
    let pais = null
    // let newState = { phone: phone }
    let newState = { };


    if (value) {

      if (this.props.type === "ddi") {
        pais = ddi.filter(item => {
          return item.DDI === value.replace("+", "");
        })

        if (pais.length > 0) {
          if (pais.length > 1) {
            newState.ddiList = pais;
            newState.selectToggle = true;             
          } else {
            newState.DDI = pais[0].DDI
            newState.ArquivoBandeira = pais[0].ArquivoBandeira
            newState.Nome = pais[0].Nome
            newState.ddiList = ddi
            newState.selectToggle = false

            const {onChangeDDI} = this.props;
            onChangeDDI(pais[0].IdPais);
          }         
        } else {
          newState.DDI = ""
          newState.ArquivoBandeira = ""
          newState.Nome = ""
          newState.selectToggle = false
        }
      } else {
        newState = { phone: value }
      }
    } else {
      newState.DDI = ""
      newState.ArquivoBandeira = ""
      newState.selectToggle = false
    }

    this.setState(newState);
  }


  // onChangeSelectCountry = event => {
  //   this.alterValuePhone(event.target.value)

  // }

  selectToggle = () => {
    const ddi = this.props.listPais;
    this.setState({ selectToggle: !this.state.selectToggle, ddiList: ddi })
  }

  onClickSelectItem = item => {
    this.setState({ ...this.state, ...item, paisNotexist: false });
    // this.alterValuePhone(item.ddi)
    this.selectToggle();
    this.input.focus();

    let { name } = this.input;
    let { onChange, onChangeDDI } = this.props;


    if (onChange) {
      onChange(name, item.DDI)
    }

    onChangeDDI(item.IdPais);
  }

  alterValuePhone = (ddi, ) => {
    let newValue = {}
    newValue = {ddi: ddi, paisNotexist: false};

    this.setState(newValue)

    let { name } = this.input
    let { onChange } = this.props


    if (onChange) {
      onChange(name, newValue.ddi)
    }
  }

}

FieldTelefone.protoTypes = {
  type: PropTypes.string,
  value: PropTypes.string,
  name: PropTypes.string,
  pattern: PropTypes.string,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  ddiForMask: PropTypes.string,
  onChangeDDI: PropTypes.func
}

export default FieldTelefone

